import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const VIEW_SIZE_BREADCRUMB_REQUEST = 'VIEW_SIZE_BREADCRUMB_REQUEST';
export const VIEW_SIZE_BREADCRUMB_SUCCESS = 'VIEW_SIZE_BREADCRUMB_SUCCESS';
export const VIEW_SIZE_BREADCRUMB_ERROR = 'VIEW_SIZE_BREADCRUMB_ERROR';
export const RESET_VIEW_SIZE_BREADCRUMB = 'RESET_VIEW_SIZE_BREADCRUMB';


export const sectionBreadcrumb = (id) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: VIEW_SIZE_BREADCRUMB_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/pattern/sectionBreadcrumb/${id}`,
                headers: headers,

            }).then(function (response) {
                dispatch({
                    type: VIEW_SIZE_BREADCRUMB_SUCCESS,
                    payload: response
                })

                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: VIEW_SIZE_BREADCRUMB_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })

    }
}

export const resetViewSIZE = () => {
    return dispatch => {
        dispatch({
            type: RESET_VIEW_SIZE_BREADCRUMB
        })
    }
}



